<template>
  <el-dialog width="600px" title="批量修改客户对账状态" v-model="isvisible">
    <el-form
      ref="customerFormRef"
      :model="customerForm"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="客户对账状态" prop="cusstatus">
        <el-select
          v-model="customerForm.cusstatus"
          placeholder="选择客户对账状态"
          style="width: 100%"
        >
          <el-option label="已对账" :value="1" />
          <el-option label="未对账" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="客户收款状态" prop="cuspaystatus">
        <el-select v-model="customerForm.cuspaystatus" placeholder="客户收款状态" style="width: 100%">
          <el-option label="已收款" :value="1" />
          <el-option label="未收款" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="客户结算状态" prop="cussetstatus">
        <el-select
          v-model="customerForm.cussetstatus"
          placeholder="选择客户结算状态"
          style="width: 100%"
        >
          <el-option label="已结算" :value="1" />
          <el-option label="未结算" :value="2" />
          <el-option label="已抵扣" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item label="应收金额" prop="cuspaidamount">
        <el-input
          v-model.trim="customerForm.cuspaidamount"
          placeholder="请输入应收金额"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="danger" @click="doFinanceCustomer" :loading="loading" >{{
          loading ? "提交中 ..." : "确认"
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
    <script setup>
import { ref, defineExpose, defineEmits } from "vue";
import { ElMessage } from "element-plus";
import { batchSaveOrderCustomerStatus } from "@/api/order/verify";

let timer;

const emit = defineEmits(["click"]); // 声明父触发事件

const loading = ref(false);

const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

const customerFormRef = ref();
const customerForm = ref({
  orderid: "",
  cuscompensation: "",
  cusstatus: "",
  cuspaystatus: "",
  cuspaidamount: "",
  cussetstatus: "",
});

const customerMethod = (obj) => {
  customerForm.value = {
    orderid: obj.orderid,
    cuscompensation: obj.cuscompensation
  };
};

defineExpose({ changeVisible, customerMethod });

const doFinanceCustomer = () => {
  customerFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    let orders = [];
    let orderids = customerForm.value.orderid;
    let cuscompensations = customerForm.value.cuscompensation;

    for (let i = 0; i < orderids.length; i++) {
      orders.push({
        orderid: orderids[i],
        cuscompensation: cuscompensations[i],
        cusstatus: customerForm.value.cusstatus,
        cuspaystatus: customerForm.value.cuspaystatus,
        cuspaidamount: customerForm.value.cuspaidamount,
        cussetstatus: customerForm.value.cussetstatus,
      });
    }

    batchSaveOrderCustomerStatus(orders).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          closeDialog();
          emit('click')
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

const closeDialog = () => {
  isvisible.value = false;
  customerFormRef.value.resetFields();
  clearTimeout(timer);
};

const validateDecimal = (rule, value, callback) => {
  //console.log('---value',value)
  if (value===''|| typeof(value)=='undefined') {
    callback();
  }
  const reg = /^(\d+\.?)?\d{0,2}$/;
  if (!String(value).match(reg)) {
    callback(new Error("只能填写整数、小数须保留两位小数"));
  } else {
    callback();
  }
};
//表单验证规则
const rules = ref({
  // cusstatus: [
  //   {
  //     required: true,
  //     message: "请选择客户对账状态",
  //     trigger: "change",
  //   },
  // ],
  cuspaidamount: [
    {
      // required: true,
      message: "请输入应收金额",
      trigger: "blur",
    },
    {
      // required: true,
      validator: validateDecimal,
      trigger: "blur",
    },
  ],
  // cussetstatus: [
  //   {
  //     required: true,
  //     message: "请选择客户结算状态",
  //     trigger: "change",
  //   },
  // ],
});
</script>
    <style scoped>
.el-dialog {
  text-align: left;
}
.el-dialog__body {
  padding-top: 15px;
}
</style>